module.exports = __webpack_public_path__ + "img/icon-check.376e359e.svg";